import { NewsCategorySideInput } from "../../components"
import { useOutletContext } from "react-router-dom";

const MainAdminNewsCategoryAdd = () => {
   // const [setRecheck,reCheck] = useOutletContext();

    return(
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[120px] border-borderGray border-2">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2">افزودن دسته بندی تازه</p>
            <div className="my-[22px]"><NewsCategorySideInput /></div>
       
        </div>
    )
}

export default MainAdminNewsCategoryAdd;